import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Modal, Alert, Button } from 'react-bootstrap';
import { CompanySideBar } from '../../components/CompanySideBar';
import { getVacancies, getVacancyById, deleteVacancy, toggleVacancyActive } from '../../services/VacanciesService';
import { LogoSpinner } from '../../components/LogoSpinner';

export function CompanyManage() {
    const history = useHistory();
    const [vacancies, setVacancies] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedVacancy, setSelectedVacancy] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [loadingDetail, setLoadingDetail] = useState(false);
    const [deletingId, setDeletingId] = useState(null);
    const [togglingId, setTogglingId] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [vacancyToDelete, setVacancyToDelete] = useState(null);

    const loadVacancies = async () => {
        try {
            setLoading(true);
            setError(null);
            const response = await getVacancies();
            setVacancies(response.data || []);
        } catch (err) {
            const errorMessage = err.response?.data?.message || err.message || 'Error al cargar las vacantes. Por favor, intenta nuevamente.';
            setError(errorMessage);
            console.error('Error loading vacancies:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadVacancies();
    }, []);

    const handleViewVacancy = async (id) => {
        try {
            setLoadingDetail(true);
            const response = await getVacancyById(id);
            setSelectedVacancy(response.data);
            setShowModal(true);
        } catch (err) {
            alert('Error al cargar los detalles de la vacante. Por favor, intenta nuevamente.');
            console.error('Error loading vacancy detail:', err);
        } finally {
            setLoadingDetail(false);
        }
    };

    const handleDeleteClick = (id, titulo) => {
        setVacancyToDelete({ id, titulo });
        setShowDeleteModal(true);
    };

    const handleConfirmDelete = async () => {
        if (!vacancyToDelete) return;

        try {
            setDeletingId(vacancyToDelete.id);
            await deleteVacancy(vacancyToDelete.id);
            setShowDeleteModal(false);
            setVacancyToDelete(null);
            await loadVacancies();
        } catch (err) {
            const errorMessage = err.response?.data?.message || err.message || 'Error al eliminar la vacante. Por favor, intenta nuevamente.';
            alert(errorMessage);
            console.error('Error deleting vacancy:', err);
        } finally {
            setDeletingId(null);
        }
    };

    const handleToggleActive = async (id) => {
        try {
            setTogglingId(id);
            await toggleVacancyActive(id);
            await loadVacancies();
        } catch (err) {
            const errorMessage = err.response?.data?.message || err.message || 'Error al cambiar el estado de la vacante. Por favor, intenta nuevamente.';
            alert(errorMessage);
            console.error('Error toggling vacancy:', err);
        } finally {
            setTogglingId(null);
        }
    };

    const handleEditVacancy = (id) => {
        history.push(`/company-post-jobs?id=${id}`);
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };

    const getRelationName = (relation) => {
        return relation?.nombre || 'N/A';
    };

    if (loading) {
        return <LogoSpinner />;
    }

    if (error && vacancies.length === 0) {
        return (
            <div className="page-content bg-white">
                <div className="content-block">
                    <div className="section-full bg-white p-t50 p-b20">
                        <div className="container">
                            <div className="row">
                                <CompanySideBar />
                                <div className="col-xl-9 col-lg-8 m-b30">
                                    <Alert variant="danger">
                                        <Alert.Heading>Error al cargar las vacantes</Alert.Heading>
                                        <p>{error}</p>
                                        <Button variant="primary" onClick={loadVacancies}>
                                            Reintentar
                                        </Button>
                                    </Alert>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            <style>{`
                .detail-section {
                    margin-bottom: 25px;
                    padding: 15px;
                    background-color: #f8f9fa;
                    border-radius: 5px;
                    border-left: 3px solid #009247;
                }
                .detail-section-title {
                    font-size: 16px;
                    font-weight: 600;
                    color: #009247;
                    margin-bottom: 15px;
                    padding-bottom: 8px;
                    border-bottom: 1px solid #dee2e6;
                }
                .detail-item {
                    margin-bottom: 12px;
                }
                .detail-item strong {
                    display: block;
                    color: #495057;
                    font-size: 13px;
                    margin-bottom: 4px;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                }
                .detail-item p {
                    margin: 0;
                    color: #212529;
                    font-size: 14px;
                    word-break: break-word;
                }
                .badge-success {
                    background-color: #28a745;
                    color: white;
                    padding: 4px 8px;
                    border-radius: 3px;
                    font-size: 12px;
                }
                .badge-danger {
                    background-color: #dc3545;
                    color: white;
                    padding: 4px 8px;
                    border-radius: 3px;
                    font-size: 12px;
                }
                .delete-confirm-modal {
                    z-index: 1000000 !important;
                }
                .delete-confirm-modal .modal-dialog {
                    z-index: 1000001 !important;
                    position: relative;
                }
                .delete-confirm-modal .modal-content {
                    z-index: 1000001 !important;
                    position: relative;
                    pointer-events: auto !important;
                }
                .delete-confirm-modal .modal-header,
                .delete-confirm-modal .modal-body,
                .delete-confirm-modal .modal-footer {
                    pointer-events: auto !important;
                    position: relative;
                }
                .delete-confirm-modal .modal-header button,
                .delete-confirm-modal .modal-footer button {
                    pointer-events: auto !important;
                    position: relative;
                    cursor: pointer;
                }
                .delete-confirm-modal .modal-footer button:disabled {
                    pointer-events: none;
                    opacity: 0.6;
                }
                body.modal-open .delete-confirm-modal + .modal-backdrop {
                    z-index: 999999 !important;
                }
                body.modal-open .delete-confirm-modal {
                    z-index: 1000000 !important;
                }
            `}</style>
            <div className="page-content bg-white">
                <div className="content-block">
                    <div className="section-full bg-white p-t50 p-b20">
                        <div className="container">
                            <div className="row">
                                <CompanySideBar />
                                <div className="col-xl-9 col-lg-8 m-b30">
                                    <div className="job-bx browse-job clearfix">
                                        <div className="job-bx-title clearfix">
                                            <h5 className="font-weight-700 pull-left text-uppercase">Administrar Vacantes</h5>
                                            <Link to="/company-post-jobs" className="site-button right-arrow button-sm float-right">
                                                Publicar Nueva Vacante
                                            </Link>
                                        </div>

                                        {error && vacancies.length > 0 && (
                                            <Alert variant="warning" dismissible onClose={() => setError(null)}>
                                                {error}
                                            </Alert>
                                        )}

                                        {!loading && vacancies.length === 0 ? (
                                            <div className="text-center p-t50 p-b50">
                                                <p className="m-b20">No tienes vacantes publicadas aún.</p>
                                                <Link to="/company-post-jobs" className="site-button">
                                                    Publicar Primera Vacante
                                                </Link>
                                            </div>
                                        ) : (
                                            <>
                                                <table className="table-job-bx cv-manager company-manage-job">
                                                    <thead>
                                                        <tr>
                                                            <th>Vacante</th>
                                                            <th>Postulaciones</th>
                                                            <th>Estatus</th>
                                                            <th>Acciones</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {vacancies.map((vacancy) => (
                                                            <tr key={vacancy.id}>
                                                                <td className="job-name">
                                                                    <Link to={`/company-post-jobs?id=${vacancy.id}`} style={{ color: '#333', textDecoration: 'none', transition: 'color 0.3s ease' }}>
                                                                        {vacancy.titulo}
                                                                    </Link>
                                                                    <ul className="job-post-info">
                                                                        <li>
                                                                            <i className="fa fa-map-marker"></i>
                                                                            {getRelationName(vacancy.ciudad)}, {getRelationName(vacancy.pais)}
                                                                        </li>
                                                                        <li>
                                                                            <i className="fa fa-bookmark-o"></i>
                                                                            {getRelationName(vacancy.modalidadTrabajo)}
                                                                        </li>
                                                                        <li>
                                                                            <i className="fa fa-filter"></i>
                                                                            {getRelationName(vacancy.categoria)}
                                                                        </li>
                                                                    </ul>
                                                                </td>
                                                                <td className="application text-primary">
                                                                    (0) Aplicaciones
                                                                </td>
                                                                <td className={`expired ${vacancy.activa ? 'success' : 'text-red'}`}>
                                                                    {vacancy.activa ? 'Activa' : 'Inactiva'}
                                                                </td>
                                                                <td className="job-links">
                                                                    <Link
                                                                        to={"#"}
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            handleEditVacancy(vacancy.id);
                                                                        }}
                                                                        title="Editar"
                                                                        className="m-l10"
                                                                    >
                                                                        <i className="fa fa-edit"></i>
                                                                    </Link>
                                                                    <Link
                                                                        to={"#"}
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            handleToggleActive(vacancy.id);
                                                                        }}
                                                                        title={vacancy.activa ? "Desactivar" : "Activar"}
                                                                        className="m-l10"
                                                                        disabled={togglingId === vacancy.id}
                                                                    >
                                                                        {togglingId === vacancy.id ? (
                                                                            <span className="spinner-border spinner-border-sm" role="status"></span>
                                                                        ) : (
                                                                            <i className={`fa fa-${vacancy.activa ? 'toggle-on' : 'toggle-off'}`}></i>
                                                                        )}
                                                                    </Link>
                                                                    <Link
                                                                        to={"#"}
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            handleDeleteClick(vacancy.id, vacancy.titulo);
                                                                        }}
                                                                        title="Eliminar"
                                                                        className="m-l10 text-danger"
                                                                        disabled={deletingId === vacancy.id}
                                                                    >
                                                                        {deletingId === vacancy.id ? (
                                                                            <span className="spinner-border spinner-border-sm" role="status"></span>
                                                                        ) : (
                                                                            <i className="ti-trash"></i>
                                                                        )}
                                                                    </Link>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={showModal} onHide={() => setShowModal(false)} className="modal fade modal-bx-info" size="xl">
                <div className="modal-dialog my-0" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="logo-img">
                                <img alt="" src={require("./../../images/logo/icon2.png")} />
                            </div>
                            <h5 className="modal-title">
                                {selectedVacancy?.titulo || 'Detalle de Vacante'}
                            </h5>
                            <button type="button" className="close" onClick={() => setShowModal(false)}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {loadingDetail ? (
                                <div className="text-center p-t20 p-b20">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="sr-only">Cargando...</span>
                                    </div>
                                </div>
                            ) : selectedVacancy ? (
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="detail-section">
                                            <h6 className="detail-section-title">Información General</h6>
                                            <div className="detail-item">
                                                <strong>Título:</strong>
                                                <p>{selectedVacancy.titulo}</p>
                                            </div>
                                            <div className="detail-item">
                                                <strong>Email de Contacto:</strong>
                                                <p>{selectedVacancy.emailContacto}</p>
                                            </div>
                                            <div className="detail-item">
                                                <strong>Tags:</strong>
                                                <p>{selectedVacancy.tags || 'N/A'}</p>
                                            </div>
                                            <div className="detail-item">
                                                <strong>Inglés Requerido:</strong>
                                                <p>
                                                    <span className={selectedVacancy.inglesRequerido ? 'text-success' : 'text-muted'}>
                                                        {selectedVacancy.inglesRequerido ? 'Sí' : 'No'}
                                                    </span>
                                                </p>
                                            </div>
                                            <div className="detail-item">
                                                <strong>Estado:</strong>
                                                <p>
                                                    <span className={`badge ${selectedVacancy.activa ? 'badge-success' : 'badge-danger'}`}>
                                                        {selectedVacancy.activa ? 'Activa' : 'Inactiva'}
                                                    </span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="detail-section">
                                            <h6 className="detail-section-title">Detalles del Trabajo</h6>
                                            <div className="detail-item">
                                                <strong>Modalidad de Trabajo:</strong>
                                                <p>{getRelationName(selectedVacancy.modalidadTrabajo)}</p>
                                            </div>
                                            <div className="detail-item">
                                                <strong>Tipo de Trabajo:</strong>
                                                <p>{getRelationName(selectedVacancy.tipoTrabajo)}</p>
                                            </div>
                                            <div className="detail-item">
                                                <strong>Tipo de Contrato:</strong>
                                                <p>{getRelationName(selectedVacancy.tipoContratoTrabajo)}</p>
                                            </div>
                                            <div className="detail-item">
                                                <strong>Experiencia Requerida:</strong>
                                                <p>{getRelationName(selectedVacancy.tiempoExperienciaRequerido)}</p>
                                            </div>
                                            <div className="detail-item">
                                                <strong>Categoría:</strong>
                                                <p>{getRelationName(selectedVacancy.categoria)}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="detail-section">
                                            <h6 className="detail-section-title">Compensación</h6>
                                            <div className="detail-item">
                                                <strong>Salario:</strong>
                                                <p>
                                                    {selectedVacancy.salarioMinimo && selectedVacancy.salarioMaximo
                                                        ? `$${selectedVacancy.salarioMinimo.toLocaleString()} - $${selectedVacancy.salarioMaximo.toLocaleString()}`
                                                        : selectedVacancy.salarioMinimo
                                                            ? `Desde $${selectedVacancy.salarioMinimo.toLocaleString()}`
                                                            : selectedVacancy.salarioMaximo
                                                                ? `Hasta $${selectedVacancy.salarioMaximo.toLocaleString()}`
                                                                : 'No especificado'}
                                                </p>
                                            </div>
                                            <div className="detail-item">
                                                <strong>Tiempo de Vigencia:</strong>
                                                <p>{selectedVacancy.tiempoVigencia ? `${selectedVacancy.tiempoVigencia} días` : 'N/A'}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="detail-section">
                                            <h6 className="detail-section-title">Ubicación</h6>
                                            <div className="detail-item">
                                                <strong>País:</strong>
                                                <p>{getRelationName(selectedVacancy.pais)}</p>
                                            </div>
                                            <div className="detail-item">
                                                <strong>Ciudad:</strong>
                                                <p>{getRelationName(selectedVacancy.ciudad)}</p>
                                            </div>
                                            <div className="detail-item">
                                                <strong>Dirección:</strong>
                                                <p>{selectedVacancy.direccion}</p>
                                            </div>
                                        </div>
                                    </div>
                                    {selectedVacancy.descripcion && (
                                        <div className="col-md-12">
                                            <div className="detail-section">
                                                <h6 className="detail-section-title">Descripción</h6>
                                                <div className="detail-item">
                                                    <div 
                                                        dangerouslySetInnerHTML={{ __html: selectedVacancy.descripcion }}
                                                        style={{
                                                            color: '#212529',
                                                            fontSize: '14px',
                                                            lineHeight: '1.6',
                                                            wordBreak: 'break-word'
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    <div className="col-md-12">
                                        <div className="detail-section">
                                            <h6 className="detail-section-title">Información del Sistema</h6>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="detail-item">
                                                        <strong>Fecha de Creación:</strong>
                                                        <p>{formatDate(selectedVacancy.createdAt)}</p>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="detail-item">
                                                        <strong>Última Actualización:</strong>
                                                        <p>{formatDate(selectedVacancy.updatedAt)}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <p>No se pudo cargar la información de la vacante.</p>
                            )}
                        </div>
                        <div className="modal-footer">
                            {selectedVacancy && (
                                <>
                                    <Button
                                        variant="primary"
                                        onClick={() => {
                                            setShowModal(false);
                                            handleEditVacancy(selectedVacancy.id);
                                        }}
                                    >
                                        <i className="fa fa-edit m-r5"></i>
                                        Editar Vacante
                                    </Button>
                                    <Button
                                        variant="danger"
                                        onClick={() => {
                                            setShowModal(false);
                                            handleDeleteClick(selectedVacancy.id, selectedVacancy.titulo);
                                        }}
                                    >
                                        <i className="ti-trash m-r5"></i>
                                        Eliminar
                                    </Button>
                                </>
                            )}
                            <Button variant="secondary" onClick={() => setShowModal(false)}>
                                Cerrar
                            </Button>
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal 
                show={showDeleteModal} 
                onHide={() => setShowDeleteModal(false)} 
                centered
                className="delete-confirm-modal"
                backdrop={true}
                keyboard={true}
                enforceFocus={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <i className="fa fa-exclamation-triangle text-warning m-r10"></i>
                        Confirmar Eliminación
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="text-center p-t20 p-b20">
                        <div className="m-b20">
                            <i className="fa fa-trash-o" style={{ fontSize: '48px', color: '#dc3545' }}></i>
                        </div>
                        <h5 className="m-b15">¿Estás seguro de que deseas eliminar esta vacante?</h5>
                        <p className="text-muted m-b20">
                            <strong>{vacancyToDelete?.titulo}</strong>
                        </p>
                        <p className="text-muted">
                            Esta acción no se puede deshacer. La vacante será eliminada permanentemente.
                        </p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setShowDeleteModal(false);
                            setVacancyToDelete(null);
                        }}
                        disabled={deletingId !== null}
                    >
                        Cancelar
                    </Button>
                    <Button
                        variant="danger"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleConfirmDelete();
                        }}
                        disabled={deletingId !== null}
                    >
                        {deletingId ? (
                            <>
                                <span className="spinner-border spinner-border-sm m-r5" role="status"></span>
                                Eliminando...
                            </>
                        ) : (
                            <>
                                <i className="ti-trash m-r5"></i>
                                Eliminar Vacante
                            </>
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
